import React from "react";
import { useCruise } from "../context/CruiseContext";
import { Phone, Globe, Anchor } from "lucide-react";
import { SocialLinks } from "./SocialLinks";

const Footer = () => {
  const { EVENT, logo, logoAlt } = useCruise();
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12">
          <div>
            <img
              src={logo}
              alt={logoAlt}
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-white/50 text-sm max-w-xs">
              {EVENT.edition}. {EVENT.tagline} aboard the {EVENT.ship}. {EVENT.poweredBy}.
            </p>
          </div>

          <div>
            <h4 className="font-cond uppercase tracking-widest text-white text-sm mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70">
                <Phone size={16} className="text-[#E50914]" />
                <a href={EVENT.phoneHref} className="hover:text-white transition-colors">{EVENT.phone}</a>
              </li>
              <li className="flex items-center gap-3 text-white/70">
                <Globe size={16} className="text-[#E50914]" />
                <span>{EVENT.website}</span>
              </li>
            </ul>
            <SocialLinks className="mt-5" />
          </div>

          <div>
            <h4 className="font-cond uppercase tracking-widest text-white text-sm mb-4">Ready To Sail?</h4>
            <p className="text-white/50 text-sm mb-4">Deposits as low as {EVENT.depositFrom} per person. Payment plans available.</p>
            <a href={EVENT.bookingUrl} target="_blank" rel="noopener noreferrer">
              <span className="inline-block bg-[#E50914] hover:bg-[#c20710] text-white font-cond uppercase tracking-widest text-sm px-6 py-3 transition-colors">
                Book Your Cabin
              </span>
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs font-cond uppercase tracking-widest text-center">
            This is an official House Heads At Sea event
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {[["/", "Home"], ["/escape", "The Escape"], ["/europe", "Europe"], ["/getaway", "The Getaway"], ["/press", "Press"]].map(([to, label]) => (
              <a key={to} href={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-white/40 hover:text-white text-xs font-cond uppercase tracking-widest transition-colors">
                {label}
              </a>
            ))}
            <a href="/terms" data-testid="footer-terms-link" className="text-white/40 hover:text-white text-xs font-cond uppercase tracking-widest transition-colors">
              Terms &amp; Conditions
            </a>
            <p className="text-white/40 text-xs">
              © {new Date().getFullYear()} House Heads At Sea. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
